import { render, staticRenderFns } from "./ConferenceTile.vue?vue&type=template&id=4882a07e&scoped=true&"
import script from "./ConferenceTile.vue?vue&type=script&lang=js&"
export * from "./ConferenceTile.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceTile.vue?vue&type=style&index=0&id=4882a07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882a07e",
  null
  
)

export default component.exports